import { sv } from "@dhx/ts-common/dom";
import { getCoordinates } from "../helpers/circle";
import { calcPointRef, locator } from "../helpers/common";
import { IRadarConfig, IScale, PointData, PointType, ScaleType, SvgElement } from "../types";
import { IFitPosition } from "@dhx/ts-common/html";
import BaseSeria from "./BaseSeria";

export default class Radar extends BaseSeria {
	public config: IRadarConfig;
	private _scale;
	private _locator;

	addScale(type: ScaleType, scale: IScale): void {
		this._scale = scale;
	}
	scaleReady(sizes: IFitPosition) {
		for (const key in sizes) {
			sizes[key] += this.config.paddings;
		}
		return sizes;
	}

	dataReady(prev? : PointData[]){
		if (!this.config.active){
			return this._points = [];
		}

		this._points = this._data.map((item, index) => {
			// raw values
			const value = this._locator(item);
			const set = [value, value, item.id, value, value];
			if (prev){
				set[1] += prev[index][1];
			}
			return set;
		});

		return this._points;
	}
	getTooltipText(id:string){
		if (this.config.tooltip) {
			const p = this._defaultLocator(this._data.getItem(id));
			if (this.config.tooltipTemplate) {
				return this.config.tooltipTemplate(p);
			}
			return p;
		}
	}

	paint(width: number, height: number): SvgElement {
		super.paint(width, height);

		if (!this.config.active) {
			return;
		}

		const config = this.config;
		const svg = [];

		const d = this._points.map((item, first) => (first ? "L" : "M") + `${item[0]} ${item[1]}`).join(" ") + "Z";
		svg.push(sv("path", {
			d,
			"stroke": config.color,
			"stroke-width": config.strokeWidth,
			"fill": config.fill ,
			"fill-opacity": config.alpha,
			"class": "chart radar"
		}));
		if (config.pointType) {
			const points = this._points.map(p => this._drawPointType(p[0], p[1], calcPointRef(p[2], this.id)));
			svg.push(sv("g", points));
		}
		return sv("g", { id: "seria" + config.id }, svg);
	}
	protected _calckFinalPoints(width: number, height: number) {
		const radius = height / 2;
		const scalePercent = 1 / this._data.getLength();
		let currentPercent = -.25 - scalePercent;

		this._points.forEach((item, index) => {
			currentPercent += scalePercent;
			const value = this._scale.point(item[0]);
			const real = getCoordinates(currentPercent, value * radius, value * radius);

			// scaled values
			item[0] = real[0] + width/2;
			item[1] = real[1] + height/2;
		});
	}
	protected _defaultLocator(v){ return this._locator(v); }
	protected _setDefaults(config: IRadarConfig): void {
		const defaults = {
			strokeWidth: 2,
			active: true,
			tooltip: true,
			paddings: 5,
			color: "none",
			fill: "none",
			pointType: PointType.circle
		};

		this._locator = locator(config.value);

		config.scales = config.scales || [ScaleType.radial];

		this.config = {...defaults, ...config};
		if (this.config.pointType) {
			const color = this.config.pointColor || this.config.color;
			this._drawPointType = this._getPointType(this.config.pointType, color, this.config.tooltip);
		}
	}
}